import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { trakrefBlue, inputGrey } from "../../../color_utils";
import PropTypes from "prop-types";
import { trakrefFontFamily } from "../../../utils";

const defaultStlyes = {
    "& label.Mui-focused": {
        color: trakrefBlue,
    },
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: trakrefBlue,
        },
    },
    "& .MuiFilledInput-root": {
        backgroundColor: inputGrey,
        "&.Mui-focused fieldset": {
            borderColor: trakrefBlue,
        },
    },
    "&  .MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
        color: "#D51A1A !important",
    },
    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
        textTransform: "uppercase",
    },
    "& .MuiFilledInput-root.Mui-error:after": {
        borderBottom: "2px solid #D51A1A !important",
    },
    "& .MuiFilledInput-root:after": {
        borderBottomColor: trakrefBlue,
    },
};

const validateValue = (value) => {
    if (!value) return false;

    const isValid = String(value)
        .toLowerCase()
        .match(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);

    return !isValid;
};

const errorMessages =
    "Please enter a valid phone number. (For example : +1 (555) 555-1234)";

const InputPhone = ({
    id,
    required,
    label,
    value,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    error,
    fullWidth,
    variant,
    helperText,
    multiLine,
    type,
    disabled,
    rows,
    maxCharacterLength,
    sx,
    isValid,
}) => {
    const [currentError, setCurrentError] = useState(error);
    const [currentHelperText, setCurrentHelperText] = useState(errorMessages);

    useEffect(() => {
        setCurrentHelperText(helperText);
    }, [helperText]);

    useEffect(() => {
        const isValidValue = validateValue(value);
        const errorExist = isValidValue || error;

        setCurrentError(errorExist);
        setCurrentHelperText(isValidValue ? errorMessages : helperText);
    }, [value, error]);

    useEffect(() => {
        isValid(currentError);
    }, [currentError]);

    return (
        <TextField
            id={id}
            required={required}
            disabled={disabled}
            InputProps={{
                notched: !!value || value === 0,
                inputProps: {
                    sx: {
                        fontFamily: trakrefFontFamily
                    },
                    maxLength: maxCharacterLength,
                }
            }}
            InputLabelProps={{ shrink: !!value || value === 0 }}
            label={label}
            value={value}
            defaultValue={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            error={currentError}
            rows={rows}
            fullWidth={fullWidth}
            variant={variant}
            helperText={currentError ? currentHelperText : ""}
            multiline={multiLine}
            type={type}
            sx={{ ...defaultStlyes, ...sx }}
        />
    );
};

InputPhone.propTypes = {
    required: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    error: PropTypes.bool,
    fullWidth: PropTypes.bool,
    variant: PropTypes.string,
    helperText: PropTypes.string,
    multiLine: PropTypes.bool,
    numberInput: PropTypes.string,
    disabled: PropTypes.bool,
    maxCharacterLength: PropTypes.number,
    id: PropTypes.string,
    sx: PropTypes.object,
    isValid: PropTypes.func,
};

InputPhone.defaultProps = {
    required: false,
    disabled: false,
    error: false,
    fullWidth: false,
    variant: "outlined",
    helperText: "This field is required",
    multiLine: false,
    numberInput: "",
    onFocus: () => { },
    onBlur: () => { },
    onKeyDown: () => { },
    maxCharacterLength: 50000,
    id: "",
    sx: {},
    isValid: () => { },
};

export default InputPhone;
